import React from "react"
import App from "theme/base/App"

import "./braunco.scss"
import shop from "shop/shop";


shop.config.MIN_ORDER_VALUE = 0
shop.config.useAdditionalUSTNotice = true
shop.config.useAdditionalDeliveryNotice = true
shop.config.useTaxNotice = function TaxNotice() {
    return <div className="tr">zzgl. MwSt.</div>
}
export default App


// WEBPACK FOOTER //
// ./src/theme/giraffiti/App.js